<template>
  <div class="logo" ref="logo" style="flex: auto;width: auto;">
    <span style="color:#FFF;">
      <!-- {{nickname}} -->
    
      </span>
      <h1>{{name}}</h1>
    <!-- <router-link :to="{name:'dashboard'}">
      <LogoSvg alt="logo" />
      <img src="https://gitee.com/li_haodong/picture_management/raw/master/pic/WechatIMG9.png" alt="pre系统logo" style="max-width: 100%;max-height: 100%">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link> -->
  </div>
</template>

<script>
//import LogoSvg from '@/assets/logo.svg?inline'
import { mapActions, mapGetters } from 'vuex'
import { axios } from '@/utils/request'
// const parentClientWidth = this.$refs.logo.clientWidth;
export default {
  name: 'Logo',
  components: {
    //LogoSvg
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])
    
  },
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    
    title: {
      type: String,
      // default: 'Pre X',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data(){
    return {
      name:""
    };
  },
  created () {
  },
  methods: {
    handleStepOk () {
      console.log('mode'+mode)
      // console.log(this.$refs.logo.clientWidth)
    },
  }
}
</script>
<style scoped>
.logo{
  flex: auto;
  width: auto;
}
h1{
  font-size: 18px !important;
}
</style>